<template>
<div id="contract">
  <div class="row" v-if="nothingToShow !=''">
  <div class="col text-center">
  <h3>{{nothingToShow}}</h3>
  </div>
  </div>
<div class="container fluid" v-else-if="isLoaded && user.authenticated">
<div class="row">
<div class="col-md-6">
<h4>Finance Information</h4>
<p>
<span>Original Equipment Cost: </span>{{contractinfo.financeDetail.amount | currency}}<br>
<span>Term (months): </span>{{contractinfo.financeDetail.termInMonths}}<br>
<span>Number of Payments remaining: </span>{{contractinfo.financeDetail.numRemainingPayments}}<br>
<span>Total Monthly Payment: </span>{{contractinfo.financeDetail.totalMonthlyPayment | currency}}<br>
<span>Purchase Option: </span>{{contractinfo.financeDetail.purchaseOption}}<br>
<span>Start Date:</span> {{contractinfo.financeDetail.fundDate | moment('MM-DD-YYYY')}}<br>
</p>
</div>
<div class="col-md-6">
<h4>Company Information</h4>
<p>
<span>Business Name: </span>{{contractinfo.companyDetail.name}}<br>
<span>Billing address: </span><br>{{contractinfo.companyDetail.billingAddress}}<br>{{contractinfo.companyDetail.billingCityStateZip}}
<br>
<br>
<span>Customer Address: </span><br>{{contractinfo.companyDetail.customerAddress}}<br>{{contractinfo.companyDetail.customerCityStateZip}}
<br>
<br>
<span>Phone Number: </span>{{contractinfo.companyDetail.phoneNumber}}<br>
<span>Email Address: </span>{{contractinfo.companyDetail.email}}<br>
</p>
</div>
</div>
<div class="row">
<div class="col-md-6">
<p>
<b-btn class="btn btn-primary" style="display:none;" v-b-modal="modalFees(parentData)">Fee Information</b-btn>
</p>
</div>
</div>
<b-row>
  <b-col>
    <h4>Equipment Information</h4>
    <table class=" table table-striped table-bordered table-hover table-fixed">
      <tr>
        <th>Type</th>
        <th>Equipment Cost</th>
        <th>New or Used</th>
        <th>Titled</th>
      </tr>
      <tbody>
      <tr v-for="(results, index) in contractinfo.equipmentDetail" :key="index">
        <td>{{results.equipmentType}}</td>
        <td>{{results.equipmentCost | currency}}</td>
        <td><span v-if="results.isNew" class="noBold">New</span><span v-else class="noBold">Used</span></td>
        <td><span v-if="results.isTitled" class="noBold">Yes</span><span v-else class="noBold">No</span></td>
      </tr>
      </tbody>
    </table>
  </b-col>
</b-row>
</div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalContract',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      equipmentdetail: null,
      companydetail: '',
      financedetail: '',
      contractinfo: null,
      user: auth.user,
      nothingToShow: 'There is no information to display at this time',
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    modalFees (key) {
      return 'modalFees' + key
    }
  },
  mounted: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/details', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.contractinfo = response.data
        this.nothingToShow = ''
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('contractinfo') &&
      this.contractinfo != null) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
#contract span {
  font-weight:bold;
}
#contract span.noBold {
  font-weight:normal;
}
</style>



// WEBPACK FOOTER //
// src/modalContract.vue